export enum AffiliateEmptyStateEnum {
  NoActivity = 'noActivity',
  NoMatch = 'noMatch',
  NoPeriodData = 'noPeriodData',
}
